import { memo } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { InputSchedulesWithDelivery } from '@/components/FormFields/InputSchedulesWithDelivery';

import { TProgramBroadcastGenerationForm } from '../../hooks/useProgramBroadcastGeneration';

type TGenerationSlotsFieldProps = {
  form: UseFormReturn<TProgramBroadcastGenerationForm>;
};

/**
 * The editable slot list, mounted exactly as the programme form mounts it.
 *
 * It is memoised on purpose. `InputSchedulesWithDelivery` hands
 * `DailySchedulesWithDelivery` a freshly built `{ schedules: [...] }` object on
 * every render, and that component resets its internal form from it in an
 * effect keyed on that object — so any re-render of the parent re-seeds the
 * list. In the programme form the parent only re-renders on its own form
 * changes; in this modal the period changes too. Memoising on the stable `form`
 * keeps a period change from reaching the slot editor at all, while the
 * `Controller` inside still re-renders on real slot changes.
 */
export const GenerationSlotsField = memo(function GenerationSlotsField({
  form,
}: TGenerationSlotsFieldProps) {
  return <InputSchedulesWithDelivery form={form} name="schedule" isOptionalEndHour />;
});
